export default __webpack_public_path__ + "static/media/secondMobile.3269ca4c.svg";